import React from 'react'
import ManageBooks from '../manage-books/ManageBooks'
import { ELibraryCategory } from '../../enum/elibrary_enum'
import { routeName } from '../../../../routes/routeName'
import { useTranslation } from 'react-i18next'

type Props = {}

const ManageVideos: React.FC<Props> = ({ }: Props) => {
    const { t } = useTranslation()
    return (
        <ManageBooks
            button_add_name={t("เพิ่มวีดีโอ")}
            category={ELibraryCategory.VIDEO}
            menu_name={t('จัดการวีดีโอ')}
            path_create={routeName.e_library.manage_videos_create}
        />
    )
}

export default ManageVideos